<template>
  <form class="review-reply-form">
    <div class="review-reply-form__header">
      <small>{{ $t('APP.REVIEWS.REPLY_DESC') }}</small>
      <small>{{ reply.length }}/400</small>
    </div>

    <ElInput
      v-model="reply"
      :maxlength="400"
      autosize
      class="review-reply-form__input"
      type="textarea"
    />

    <ElButton
      type="primary"
      size="small"
      :loading="isSubmitting"
      :disabled="!reply"
      @click="submitReply"
    >
      {{ $t('SUBMIT') }}
    </ElButton>

    <ElButton type="text" size="small" @click="cancelReply">
      {{ $t('CANCEL') }}
    </ElButton>
  </form>
</template>

<script>
export default {
  name: 'ReviewReplyForm',

  props: {
    reviewId: {
      type: Number,
      required: true,
    },
    isSubmitting: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      reply: '',
    };
  },

  methods: {
    submitReply() {
      this.$emit('submit-reply', this.reply, () => {
        this.reply = '';
      });
    },

    cancelReply() {
      this.$emit('cancel-reply');
      this.reply = '';
    },
  },
};
</script>

<style lang="scss">
.review-reply-form {
  background: rgba($clouds, 0.8);

  &__header {
    display: flex;
    justify-content: space-between;
  }

  &__input {
    margin: $global-margin / 2 0;
  }
}
</style>
